import styled from 'styled-components';

export const GlobalWrapperStyled = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;
